import * as React from "react"
import {SelectSeeker} from "ui-seeker/core"

const OPTIONS = [
    {label: 'Real time Parity', value: 'web'},
    {label: 'Metasearches', value: 'meta'},
    {label: 'OTAs', value: 'ota'},
]

export default function SelectSources({...props}) {

    const myProps = {
        options: OPTIONS,
        placeholder: 'All sources',
        isClearable: true, isMulti: false,
        icon: {icon: 'browser'},
        ...props
    }

    return <SelectSeeker {...myProps} />
}
